module.exports = __webpack_public_path__ + "img/1.4523d8d8.jpg";